import React from 'react';

export function TwitchIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none">
            <path d="M3.95499 0.542652L0.0473022 4.45034V18.518H4.73653V22.4257L8.64423 18.518H11.7704L18.8042 11.4842V0.542652H3.95499ZM17.2411 10.7027L14.115 13.8288H10.9888L8.25346 16.5642V13.8288H4.73653V2.10573H17.2411V10.7027Z" fill="#F1F0E7"/>
            <path d="M14.8964 4.84132H13.3333V9.53055H14.8964V4.84132Z" fill="#F1F0E7"/>
            <path d="M10.5983 4.84118H9.03525V9.53041H10.5983V4.84118Z" fill="#F1F0E7"/>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/TwitchIcon.js